import { render, staticRenderFns } from "./HomeMessage.vue?vue&type=template&id=411c8b57&scoped=true&"
import script from "./HomeMessage.vue?vue&type=script&lang=js&"
export * from "./HomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./HomeMessage.vue?vue&type=style&index=0&id=411c8b57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411c8b57",
  null
  
)

export default component.exports